/**
 * Special build of some Honda UI components with Honda.ca theme, build for use in Honda.ca without React.
 * This file compiled to UMD and available via the global HondaUI.
 */

import React from 'react';
import ReactDOM from 'react-dom';

/* Components as needed */
import SelectWrapper from '../../components/SelectWrapper';

/* CSS as needed */
import select from '../../components/Select/Select.honda.css';
import selectWrapper from '../../components/SelectWrapper/SelectWrapper.honda.css';

const theme = {
  select,
  selectWrapper,
};

/**
 * Dropdown
 */
export const dropdown = {
  render: (elementId, props) => {
    ReactDOM.render(
      <SelectWrapper theme={theme} {...props}/>,
      document.getElementById(elementId)
    );
  }
};

/**
 * Export all components
 */
export default {
  dropdown,
};



// WEBPACK FOOTER //
// ./src/apps/hondaca/provinceSelector.js